export enum TipoItemQuestionario {
  SECAO = 'SECAO',
  OBJETIVA = 'OBJETIVA',
  DESCRITIVA = 'DESCRITIVA',
  MULTIPLA_ESCOLHA = 'MULTIPLA_ESCOLHA',
  NUMERO = 'NUMERO',
  DATA = 'DATA',
  DROPDOWN = 'DROPDOWN',
  ARQUIVO = 'ARQUIVO'
}